export const DefaultValue = {
    "defaultAvatar": "https://secure.download.dm.origin.com/production/avatar/prod/1/599/416x416.JPEG"
}